<template>
  <span>
    <v-icon v-if="person.is_approved === false" color="error">mdi-alert-circle-outline</v-icon>

    <v-icon v-if="person.is_approved === true" color="success">mdi-check-circle-outline</v-icon>

    <v-icon v-if="person.is_approved === null && person.sended" color="warning">mdi-clock-time-eight-outline</v-icon>
  </span>
</template>

<script>
export default {
  name: 'ApprovedIcon',
  props: {
    person: {
      type: Object,
    },
  },
};
</script>

<style></style>
